import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './modules/rastreo-pedido/views/Index.vue'
import Pedido from './modules/rastreo-pedido/views/Pedido.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/rastrear-pedido/:pedido',
    name: 'Pedido',
    component: Pedido,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})



export default router
